export const ACTONS = {
  INIT_APP: "INIT_APP",

  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",

  SCREEN_LOCK_REQUEST: "SCREEN_LOCK_REQUEST",
  SCREEN_UNLOCK_REQUEST: "SCREEN_UNLOCK_REQUEST",
  LOAD_CONFIGURATION_SUCCESS: "LOAD_CONFIGURATION_SUCCESS",
  LOAD_NETWORKS_SUCCESS: "LOAD_NETWORKS_SUCCESS",
  LOAD_NETWORKS_FAILED: "LOAD_NETWORKS_FAILED",
  LOAD_NETWORK_PRODUCTS_SUCCESS: "LOAD_NETWORK_PRODUCTS_SUCCESS",
  LOAD_NETWORK_PRODUCTS_FAILED: "LOAD_NETWORK_PRODUCTS_FAILED",
  LOAD_WARRANTIES_SUCCESS: "LOAD_WARRANTIES_SUCCESS",
  LOAD_WARRANTIES_FAILED: "LOAD_WARRANTIES_FAILED",
  LOAD_TARIFFS_SUCCESS: "LOAD_TARIFFS_SUCCESS",
  LOAD_TARIFFS_FAILED: "LOAD_TARIFFS_FAILED",
  LOAD_TARIFF_GROUPS_SUCCESS: "LOAD_TARIFF_GROUPS_SUCCESS",
  LOAD_TARIFF_GROUPS_FAILED: "LOAD_TARIFF_GROUPS_FAILED",
  LOAD_AGENTS_SUCCESS: "LOAD_AGENTS_SUCCESS",
  LOAD_AGENTS_FAILED: "LOAD_AGENTS_FAILED",
  LOAD_CUSTOMERS_SUCCESS: "LOAD_CUSTOMERS_SUCCESS",
  LOAD_CUSTOMERS_FAILED: "LOAD_CUSTOMERS_FAILED",
  LOAD_USERS_SUCCESS: "LOAD_USERS_SUCCESS",
  LOAD_USERS_FAILED: "LOAD_USERS_FAILED",
  LOAD_COMPANIES_SUCCESS: "LOAD_COMPANIES_SUCCESS",
  LOAD_COMPANIES_FAILED: "LOAD_COMPANIES_FAILED",

  LOAD_RENDICONTAZIONE_SUCCESS: "LOAD_RENDICONTAZIONE_SUCCESS",
  LOAD_RENDICONTAZIONE_FAILED: "LOAD_RENDICONTAZIONE_FAILED",

  UPDATE_CONTRAENTE: "UPDATE_CONTRAENTE",
  SAVE_CONTRACT_SUCCESS: "SAVE_CONTRACT_SUCCESS",
  LOAD_CONTRACTS_SUCCESS: "LOAD_CONTRACTS_SUCCESS",
  LOAD_CONTRACTS_FAILED: "LOAD_CONTRACTS_FAILED",
};

export const AUTHENTICATION = {
  ReCaptcha: "6LfRUEkrAAAAAJ9HmKVBmI2UrS_-I_GNuF_YIwl7",
  COOKIE_NAME: "gefItAuth",
  USER_ROLE: {
    Admin: 1,
    Fab: 2,
    Seb: 3,
    NetworkOwner: 4,
    NetworkReferent: 5,
    NetworkAgent: 6,
    CentraleOperativa: 7,
    NetworkMaster: 8,
  },

  XXXMLHttpRequest: function (
    token,
    url,
    method = "GET",
    contentType = "application/json"
  ) {
    var req = new XMLHttpRequest();
    req.open(method, url, true);
    req.setRequestHeader("Content-Type", contentType);
    req.setRequestHeader("X-Token", token);
    req.addEventListener(
      "readystatechange",
      function () {
        if (
          this.readyState === 4 &&
          (this.status === 401 || this.status === 403)
        ) {
          window.location.href = "#/logoff";
        }
      },
      false
    );

    return req;
  },
};

export const AGE_LIMITS = {
  THRESHOLD_AGE: 65,
  TYPES: {
    NO_LIMITS: 0,
    NO_UNDER_65: 1,
    NO_65_AND_OVER_65: 2,
    JUST_ONE_OVER_65: 3,
    NO_35_AND_OVER_35: 4,
    NO_UNDER_35_NO_65_AND_OVER_65: 5,
  },
};

export const GENERIC_ENUM = {
  contractPeriodModeTypes: [
    { value: 0, text: "Durata Annuale" },
    { value: 1, text: "Durata Anno Solare" },
    { value: 2, text: "Annuale Collettiva" },
    { value: 3, text: "Forfait" },
    { value: 4, text: "Covid-19" },
  ],
  fractionationType: [
    { value: "1", text: "Annuo" },
    { value: "2", text: "Mensile" },
    { value: "3", text: "Trimestrale" },
    { value: "4", text: "Semestrale" },
  ],
  personType: [
    { value: 0, text: "Persona Fisica" },
    { value: 1, text: "Persona Giuridica NON DISPONIBILE", disabled: "true" },
  ],
  paymentType: [
    { value: "1", text: "SEPA SDD" },
    { value: "2", text: "BB" },
    { value: "3", text: "AB" },
    { value: "4", text: "CC" },
    { value: "5", text: "CONSEL" },
  ],
  familyTreeTypes: [
    { value: 1, text: "Moglie" },
    { value: 2, text: "Marito" },
    { value: 3, text: "Figlio" },
    { value: 4, text: "Figlia" },
    { value: 5, text: "Padre" },
    { value: 6, text: "Madre" },
    { value: 8, text: "Convivente More Uxorio" },
    { value: 9, text: "Fratello" },
    { value: 10, text: "Sorella" },
  ],
  businessRoleTypes: [
    { value: 0, text: "Nessuno" },
    { value: 1, text: "Dirigente" },
    { value: 2, text: "Amministratore" },
    { value: 3, text: "Quadro" },
    { value: 4, text: "Impiegato" },
    { value: 5, text: "Operaio" },
    { value: 6, text: "Familiare non a Carico" },
  ],
  networkCategory: {
    networkMaster: [{ value: 1, text: "Grifo" }],
    networkType: [
      { value: 1, text: "Direct" },
      { value: 2, text: "Non Direct" },
      { value: 3, text: "Mixed" },
    ],
    networkGiuridicForm: [
      { value: 1, text: "Casse" },
      { value: 2, text: "Fondi" },
      { value: 3, text: "Sms" },
      { value: 4, text: "Società di Capitali" },
      { value: 5, text: "Società di Persone" },
      { value: 6, text: "Ditta Individuale" },
      { value: 8, text: "S.r.l. a Socio Unico" },
      { value: 7, text: "Altro" },
    ],
    networkSize: [
      { value: 1, text: "Small" },
      { value: 2, text: "Medium" },
      { value: 3, text: "Large" },
    ],
  },
  sex: [
    { value: 1, text: "Uomo" },
    { value: 2, text: "Donna" },
  ],
  FRAZIONAMENTO_TYPES: {
    ANNUO: 1,
    MENSILE: 2,
    TRIMESTRALE: 3,
    SEMSTRALE: 4,
  },
  DOCUMENT_TYPES: {
    GENRICO: 0,
    PREVENTIVO: 1,
    CONTRATTO: 2,
    MODULO_ADESIONE_FIRMATO: 3,
    CI: 4,
    CF: 5,
    Quietanzamento: 6,
    SEPA_SDD: 7,
    AGGIUNTA_FAMILIARE: 8,
    PROPOSTA_DIPENDENTI: 9,
    DOCUMENTO_IDENTITA: 10,
    MODULO_ADESIONE_AZIENDA_FIRMATO: 11,
    LETTERA_BENVENUTO_SEB: 12,
  },
  CONTRACT_STATUS: {
    CREAZIONE: -1,
    PREVENTIVO: 1,
    PREVENTIVO_COFERMATO: 2,
    POLIZZA: 3,
    ANNULLO: 4,
    CHIUSA: 5,
  },
  CONTRACT_PERIOD_MODE: {
    EXPIRATION_LAST_DAY_OF_YEAR: 0,
    EXPIRATION_NEXT_YEAR: 1,
    COLLETTIVA_LAST_DAY_OF_YEAR: 2,
    FORFAIT_LAST_DAY_OF_YEAR: 3,
    COVID_19: 4,
  },
  ACCOUNT_PERIOD_STATUS: {
    PAGAMENTO: 1,
    ESITO_PAGAMENTO_OK: 2,
    ESITO_PAGAMENTO_KO: 3,
    ANNULLATO: 4,
  },
  ACCOUNT_PERIOD_ACTIVITY: {
    EMISSIONE: 1,
    QUIETANZIAMENTO: 2,
    RIMBORSO: 3,
    RINNOVO: 4,
    AGGIUNTA_FAMILIARE: 5,
  },
  FAMILY_TREE_TYPES: {
    CAPO_NUCLEO: 0,
    MOGLIE: 1,
    MARITO: 2,
    FIGLIO: 3,
    FIGLIA: 4,
    PADRE: 5,
    MADRE: 6,
    LEGALE_RAPPRESENTANTE: 7,
    CONVIVENTE_MORE_UXORIO: 8,
    FRATELLO: 9,
    SORELLA: 10,
  },
  BUSINESS_ROLE_TYPES: {
    NESSUNO: 0,
    DIRIGENTE: 1,
    AMMINISTRATORE: 2,
    QUADRO: 3,
    IMPIEGATO: 4,
    OPERAIO: 5,
    FAMILIARE_NON_A_CARICO: 6,
  },
  PIANO_FLEX: {
    COMPANY_FIRST_WARRANTY: 26, // SALUTE E BENESSERE SMS
  },
  ERROR_MESSAGE: {
    BE: [
      { code: 0, message: "Errore generico sul server" },
      { code: 1, message: "Username già in uso" },
      { code: 2, message: "Compagnia già in Database" },
      { code: 3, message: "Compagnia utiizzata e non Cancellabile" },
      { code: 4, message: "Prestazione utiizzata e non Cancellabile" },
      { code: 5, message: "Password errata o mancante" },
      { code: 6, message: "Codice Fiscale errato o mancante" },
      { code: 7, message: "Dati utente mancanti" },
      { code: 8, message: "Username errato o mancante" },
      { code: 9, message: "Piano in uso e non Cancellabile" },
      { code: 10, message: "Date di inizio e fine piano errate" },
      { code: 11, message: "Date di inizio e fine piano errate" },
      {
        code: 12,
        message:
          "Alcuni Pagamenti non risultano effettuati, non è quindi possibile Rinnovare il Contratto",
      },
      {
        code: 13,
        message: "Attenzione, i pagamenti devono essere fatti in ordine",
      },
      {
        code: 14,
        message:
          "La data di rinnovo è sbagliata, deve essere maggiore della scandeza del contratto in scadenza",
      },
      { code: 15, message: "Piano in uso e non Cancellabile" },
      {
        code: 16,
        message:
          "Attenzione il cliente che si sta utilizzando è già censito, tornare nella maschera di anagrfica, cercarlo e selezionare quello proposto o chiedere agli amministratori di sistema di modificarlo nel caso si vogliano cambiare i dati anagrafici.",
      },
      {
        code: 17,
        message:
          "La data di chiusura deve essere maggiore della data di partenza della Adesione",
      },
      { code: 18, message: "Codice Fiscale Aderente errato" },
      { code: 19, message: "Codice Fiscale Familiare errato" },
      { code: 20, message: "Codice Fiscale Legale Rappresentante errato" },
      { code: 21, message: "Codice Fiscale Dipendente o Familiare errato" },
      { code: 22, message: "Gruppo in uso e quindi non eliminabile" },
      {
        code: 23,
        message:
          "Le date di inizio e fine non corrispondono ai Valori del Piano Mutualistico base",
      },
      {
        code: 24,
        message:
          "Username non corretto, utilizzare solo caratteri alfanumerici e almeno 3 caratteri",
      },
    ],
  },
  MONTHS: [
    "Gennaio",
    "Febbraio",
    "Marzo",
    "Aprile",
    "Maggio",
    "Giugno",
    "Luglio",
    "Agosto",
    "Settembre",
    "Ottobre",
    "Novembre",
    "Dicembre",
  ],
  WEEKSDAY_LONG: [
    "Domenica",
    "Lunedì",
    "Martedì",
    "Mercoledì",
    "Giovedì",
    "Venerdì",
    "Sabato",
  ],
  WEEKSDAY_SHORT: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
};

export const TEST = {
  DELAY: 1000,
};
